import React from 'react';
import { Table, Tag } from 'antd';
import { RowResult } from 'services/MassiveService';

interface Props {
  rows: RowResult[];
}

const columns = [
  {
    title: 'Fila',
    dataIndex: 'row',
    width: 80,
    align: 'center' as const,
  },
  {
    title: 'Seguimiento',
    dataIndex: 'tracking',
    width: 180,
    render: (tracking?: string) => tracking || '—',
  },
  {
    title: 'Errores',
    dataIndex: 'errors',
    render: (errors: RowResult['errors']) => (
      <div>
        {errors.map((error) => (
          <div key={`${error.column}-${error.code}`}>
            <Tag color="error">{error.column}</Tag>
            {error.message}
          </div>
        ))}
      </div>
    ),
  },
];

const MassiveErrorsTable = ({ rows }: Props) => (
  <Table
    size="small"
    rowKey="row"
    columns={columns}
    dataSource={rows}
    pagination={rows.length > 10 ? { pageSize: 10 } : false}
    scroll={{ y: 320 }}
  />
);

export default MassiveErrorsTable;
